import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const VehiclesPendingInspectionAfterGateIn = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [verificationNo, setVerificationNo] = useState("");
  const [date, setDate] = useState(new Date().toISOString());
  const [gateInNo, setGateInNo] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [driverName, setDriverName] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [previousTripNo, setPreviousTripNo] = useState("");
  const [returns, setReturns] = useState(false);
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [returnsProduct, setReturnsProduct] = useState("");
  const [returnsProductCode, setReturnsProductCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [returnsQty, setReturnsQty] = useState("");
  const [returnsReason, setReturnsReason] = useState("");
  const [returnsPoNo, setReturnsPoNo] = useState("");
  const [roadIncident, setRoadIncident] = useState(false);
  const [roadIncidentDescription, setRoadIncidentDescription] = useState("");
  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [complianceNo, setComplianceNo] = useState("");
  const [compleianceName, setComplianceName] = useState("");
  const [complianceStatus, setComplianceStatus] = useState("");
  const [complianceNarration, setComplianceNarration] = useState("");
  const [complianceList, setComplianceList] = useState([]);
  const [driversList, setDriversList] = useState([]);
  const [wbData, setWbData] = useState([]);
  const [wbName, setWbName] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [WeighBridgeData, setWeighBridgeData] = useState([]);
  const [noOfVehicles, setNoOfVehicles] = useState("");

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer
  );

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1059`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setVerificationNo(response?.data[0]?.NEW_OT_VERIFICATION_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Client's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=599`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setClientsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Client Details:", error);
      });

    //   Items List
    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filter = response?.data?.filter(
    //       (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F"
    //     );
    //     setProductsList(filter);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Item Details:", error);
    //   });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1089`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     console.log(response?.data);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Loading Order:", error);
    //   });

    //   Compliance List
    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1065`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     setComplianceList(response?.data);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Compliance List:", error);
    //   });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filterData = response?.data?.filter(
          (item) =>
            item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE"
        );
        setWeighBridgeData(filterData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching WeighBridge details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "GATE IN" &&
              item?.DEPARTMENT === VehicleDepartment
          );
          setVehiclesList(filterData);
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "GATE IN"
          );
          setVehiclesList(filterData);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  function fetchLastGateInNo(vehicle) {
    //   For Last Gate In No
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1056`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OT_GATE_IN_VEHICLE === vehicle
        );
        setGateInNo(filter[filter?.length - 1]?.OT_GATE_IN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Last Gate In No:", error);
      });
  }

  // Saving
  async function SaveGateIn() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1058`,
        {
          OT_VERIFICATION_NO: Number(verificationNo),
          OT_GATE_IN_NO: Number(gateInNo),
          OT_VERIFICATION_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VERIFICATION_TIME: currentTime,
          OT_VERIFICATION_VEHICLE: vehicleNo,
          OT_VERIFICATION_DRIVER_CODE: driverCode,
          OT_VERIFICATION_PREVIOUS_TRIP_NO: 1,
          OT_VERIFICATION_RETURNS: returns === true ? 1 : 0,
          OT_VERIFICATION_RETURNS_CLIENT: returnsClientCode
            ? returnsClientCode
            : "",
          // OT_VERIFICATION_RETURNS_PRODUCT: returnsProductCode
          //   ? returnsProductCode
          //   : "",
          OT_VERIFICATION_RETURNS_PRODUCT: "",
          OT_VERIFICATION_RETURNS_PRODUCT_QTY: 0,
          // OT_VERIFICATION_RETURNS_PRODUCT_QTY: returnsQty
          //   ? Number(returnsQty)
          //   : 0,
          OT_VERIFICATION_RETURNS_REASON: returnsReason ? returnsReason : "",
          // OT_VERIFICATION_RETURNS_PO_NO: returnsPoNo ? Number(returnsPoNo) : 0,
          OT_VERIFICATION_RETURNS_PO_NO: 0,
          // OT_VERIFICATION_ROAD_INCIDENTS: roadIncident === true ? 1 : 0,
          OT_VERIFICATION_ROAD_INCIDENTS: 0,
          OT_VERIFICATION_ROAD_INCIDENT_DESCRIPTION: "",
          // OT_VERIFICATION_ROAD_INCIDENT_DESCRIPTION: roadIncidentDescription
          //   ? roadIncidentDescription
          //   : "",
          OT_VERIFICATION_PROCEED_TO_WEIGHBRIDGE_NUMBER: wbNo
            ? Number(wbNo)
            : 0,
          OT_VERIFICATION_PROCEED_TO_STATE: proceedToStateValue,
          OT_VERIFICATION_CARRIED_OUT_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Verification Header Saved successfully`);
        console.log(`Verification Header Saved successfully`);
        await SaveVehicleCompliance();
        await SaveVehicleState();
        await SaveState();
      } else {
        setisloading(false);
        console.error(`Error while saving Verification Header`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Verification Header`, error);
    }
  }

  async function SaveVehicleCompliance() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1061`,
        {
          OT_VERIFICATION_NO: Number(verificationNo),
          // OT_COMPLIANCE_NO: complianceNo ? Number(complianceNo) : 0,
          OT_COMPLIANCE_NO: 0,
          // OT_COMPLIANCE_STATUS: complianceStatus ? complianceStatus : "",
          OT_COMPLIANCE_STATUS: "",
          OT_COMPLIANCE_NARRATION: "",
          // OT_COMPLIANCE_NARRATION: complianceNarration
          //   ? complianceNarration
          //   : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Verification Compliance Saved Successfully`);
        console.log(`Verification Compliance Saved successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Verification Compliance `);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Verification Compliance  `, error);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: proceedToStateValue,
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "GATE IN",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: proceedToStateValue,
          DOC_NO: Number(verificationNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  const handleRowClick = (value, index) => {
    setVehicleNo(value["VEHICLE REG NO"]);
    fetchLastGateInNo(value["VEHICLE REG NO"]);
    setDriverCode(value.DRIVERCODE);
    setDriverName(value.DRIVERNAME);
    setShowGateIn(true);
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles Pending Inspection After Gate In
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>
      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>
      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                    ? "NO"
                    : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[320px] h-[80%] lg:w-[1000px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            VERIFICATION
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Verification No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={verificationNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2">GateIn No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={gateInNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Previous Trip No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={previousTripNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-2">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Driver:</p>
            {/* <input
              className="w-72 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={driverName}
              readOnly
            ></input> */}
            <Select
              className="lg:w-72 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driverName
                  ? { value: driverName, label: driverName }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriverName(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-14">Returns ?:</p>
            <input
              className="w-6 h-6 border border-black lg:ml-2 rounded-md focus:outline-none focus:border-blue-500"
              type="checkbox"
              checked={returns}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setReturns(isChecked);
                if (isChecked) {
                  setProceedToState("PROCEED TO RETURNS");
                  setProceedToStateValue("SENT FOR RETURNS");
                } else {
                  setProceedToState("");
                  setProceedToStateValue("");
                }
              }}
            ></input>
          </div>

          {/* Row 3 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 w-[100px]">
              Returns Client Name :
            </p>
            <Select
              className="lg:w-72 lg:ml-4"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                returnsClient
                  ? { value: returnsClient, label: returnsClient }
                  : { value: "", label: "Select Client" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setreturnsClient(e.value);
                  const compliance = clientsList.find(
                    (item) => item.CLIENTNAME === e.value
                  );
                  setReturnsClientCode(compliance?.CLIENTCODE);
                } else {
                  setreturnsClient("");
                }
              }}
              options={[
                { value: "", label: "Select Client" },
                ...clientsList?.map((item) => ({
                  value: item.CLIENTNAME,
                  label: item.CLIENTNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-6">Returns Reason :</p>
            <textarea
              rows={2}
              className="lg:w-[400px] w-[370px]  resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={returnsReason}
              onChange={(e) => setReturnsReason(e.target.value)}
            ></textarea>

            {/* <p className="text-red-600 lg:ml-8">Returns Product :</p>
            <Select
              className="w-64 ml-2"
              value={
                returnsProduct
                  ? { value: returnsProduct, label: returnsProduct }
                  : { value: "", label: "Select Product" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setReturnsProduct(e.value);
                  const compliance = productsList.find(
                    (item) => item.MAINNAME === e.value
                  );
                  setReturnsProductCode(compliance?.ITEMCODE);
                } else {
                  setReturnsProduct("");
                }
              }}
              options={[
                { value: "", label: "Select Product" },
                ...productsList?.map((item) => ({
                  value: item.MAINNAME,
                  label: item.MAINNAME,
                })),
              ]}
            ></Select> */}
          </div>

          {/* Row 4 */}
          {/* <div className="lg:flex lg:flex-row mt-2"> */}
          {/* <p className="text-red-600 lg:ml-2">Returns Quanity:</p>
            <input
              className="w-20 h-8 border border-black lg:ml-11 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={returnsQty}
              onChange={(e) => setReturnsQty(e.target.value)}
            ></input> */}

          {/* <p className="text-red-600 lg:ml-2">Returns PO No:</p>
            <input
              className="w-20 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={returnsPoNo}
              onChange={(e) => setReturnsPoNo(e.target.value)}
            ></input> */}
          {/* </div> */}

          {/* Row 5 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Proceed To :</p>
            <Select
              className="lg:w-64 lg:ml-8"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
                { value: "SENT FOR RETURNS", label: "PROCEED TO RETURNS" },
                {
                  value: "SENT FOR WEIGHBRIDGE",
                  label: "PROCEED TO WEIGHBRIDGE",
                },
              ]}
            ></Select>

            {proceedToState === "PROCEED TO WEIGHBRIDGE" && (
              <>
                <p className="text-red-600 lg:ml-2">WeighBridge :</p>
                <Select
                  className="lg:w-48 lg:ml-4"
                  menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
                  }}
                  value={
                    wbName
                      ? { value: wbName, label: wbName }
                      : { value: "", label: "Select WeighBridge" }
                  }
                  onChange={(e) => {
                    if (e.value !== "") {
                      setWbName(e.label);
                      setWbNo(e.value);
                      const weigh = WeighBridgeData?.filter(
                        (item) => item?.WEIGHBRIGENUMBER === e.value
                      );
                      setNoOfVehicles(weigh?.length);
                    }
                  }}
                  options={[
                    { value: "", label: "Select WeighBridge" },
                    ...wbData?.map((item) => ({
                      value: item.WBNUMBER,
                      label: item.WBNAME,
                    })),
                  ]}
                ></Select>
                <p className="text-red-600 lg:ml-2">No Of Vehicles :</p>
                <input
                  className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="number"
                  value={noOfVehicles}
                  readOnly
                ></input>
              </>
            )}
            {/* <p className="text-red-600 lg:ml-4">Incidents ?:</p>
            <input
              className="w-6 h-6 border border-black lg:ml-2 rounded-md focus:outline-none focus:border-blue-500"
              type="checkbox"
              checked={roadIncident}
              onChange={(e) => setRoadIncident(!roadIncident)}
            ></input> */}

            {/* <p className="text-red-600 lg:ml-2">Incident Description :</p>
            <textarea
              rows={2}
              className="lg:w-[400px] w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={roadIncidentDescription}
              onChange={(e) => setRoadIncidentDescription(e.target.value)}
            ></textarea> */}
          </div>

          {/* Row 6 */}
          {/* <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Compliance :</p>
            <Select
              className="w-64 lg:ml-20"
              value={
                compleianceName
                  ? { value: compleianceName, label: compleianceName }
                  : { value: "", label: "Select Compliance" }
              }
              onChange={(e) => {
                if (e.value !== "") {
                  setComplianceName(e.value);
                  const compliance = complianceList.find(
                    (item) => item.OM_COMPLIANCE_NAME === e.value
                  );
                  setComplianceNo(compliance?.OM_COMPLIANCE_NO);
                } else {
                  setComplianceName("");
                }
              }}
              options={[
                { value: "", label: "Select Compliance" },
                ...complianceList.map((item) => ({
                  label: item?.OM_COMPLIANCE_NAME,
                  value: item?.OM_COMPLIANCE_NAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Compliance Status :</p>
            <Select
              className="w-64 ml-1"
              value={
                complianceStatus
                  ? { value: complianceStatus, label: complianceStatus }
                  : { value: "", label: "Select Status" }
              }
              onChange={(e) => {
                setComplianceStatus(e.value);
              }}
              options={[
                { value: "", label: "Select Status" },
                { value: "100", label: "100" },
                { value: "90", label: "90" },
                { value: "80", label: "80" },
                { value: "70", label: "70" },
                { value: "60", label: "60" },
                { value: "50", label: "50" },
                { value: "40", label: "40" },
                { value: "30", label: "30" },
                { value: "20", label: "20" },
                { value: "10", label: "10" },
                { value: "0", label: "0" },
              ]}
            ></Select>
          </div> */}

          {/* Row 7 */}
          {/* <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Compliance Narration :</p>
            <textarea
              rows={2}
              className="lg:w-[400px] w-[370px] resize-none border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={complianceNarration}
              onChange={(e) => setComplianceNarration(e.target.value)}
            ></textarea>
          </div> */}

          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                if (returns === true && !returnsClient) {
                  alert("Kindly Supply Returns Client");
                  return;
                }
                // else if (returns === true && !returnsProduct) {
                //   alert("Kindly Supply Returns Product");
                //   return;
                // } else if (returns === true && !returnsQty) {
                //   alert("Kindly Supply Returns Quantity");
                //   return;
                // } else if (returns === true && !returnsPoNo) {
                //   alert("Kindly Supply Returns Po No");
                //   return;
                // }
                else if (returns === true && !returnsReason) {
                  alert("Kindly Supply Returns Reason");
                  return;
                } else if (!driverName) {
                  alert("Kindly Supply Driver");
                  return;
                } else if (!proceedToState) {
                  alert("Kindly Supply Proceed To State");
                  return;
                } else if (
                  proceedToState === "PROCEED TO WEIGHBRIDGE" &&
                  !wbName
                ) {
                  alert("Kindly Supply Wighbridge");
                  return;
                }
                // else if (roadIncident === true && !roadIncidentDescription) {
                //   alert("Kindly Supply Road Incident Description");
                //   return;
                // }
                // else if (!compleianceName) {
                //   alert("Kindly Supply Compliance");
                //   return;
                // }
                // else if (!complianceStatus) {
                //   alert("Kindly Supply Compliance Status");
                //   return;
                // }
                // else if (!complianceNarration) {
                //   alert("Kindly Supply Compliance Narration");
                //   return;
                // }
                else {
                  await SaveGateIn();
                  setShowGateIn(false);
                  window.location.reload();
                }
              }}
            >
              VERIFY
            </button>
          </div>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default VehiclesPendingInspectionAfterGateIn;
